import { Box } from "@mui/material";
import { CalendarIcon } from "@radix-ui/react-icons";
import { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { CRENEAUX, RENDEZ_VOUS } from "../../Utils/constant";
import { find, store } from "../../services/service";
import { useStoreCreneau } from "../../store/Paramettre/creneauStore";
import { SubmitButton } from "../Widget/SubmitButton";
import { ValidateMessage } from "../Widget/ValidateMessage";

export const PriseRendezVousRaccordement = ({
  numeroTicket,
  dateAuPlutard,
}) => {
  const [dateStartRaccord, setStartDateRaccord] = useState(null);
  const [isSubmit, setIsSubmit] = useState(false);
  const [creneau, setCreneau] = useState([]);
  const baseDate = dateAuPlutard ? new Date(dateAuPlutard) : new Date();
  const minSelectableDate = new Date(baseDate);
  minSelectableDate.setDate(minSelectableDate.getDate());

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    find(CRENEAUX)
      .then((result) => {
        setCreneau(result?.data?.donnee);
      })
      .catch((err) => {});
  }, []);

  const dateDispo = useStoreCreneau();
  useEffect(() => {
    dateDispo.dateDispo(numeroTicket);
  }, []);

  const submit = (data) => {
    setIsSubmit(true);
    const raccordRequest = {
      numeroTicket: numeroTicket,
      creneauId: data.creneauIdRaccord,
      typeRdv: "RACCORDEMENT",
      dateRdv: dateStartRaccord.toLocaleDateString().replace(/\//g, "-"),
    };
    store(RENDEZ_VOUS, "application/json", raccordRequest)
      .then((res) => {
        if (res.status === 200) {
          setIsSubmit(null);
          toast.success("Prise de rendez-vous éffectuée");
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err?.response?.data?.donnee);
      });
  };
  return (
    <>
      {isSubmit !== null ? (
        <form
          onSubmit={handleSubmit(submit)}
          className="shadow-sm border rounded w-full p-8"
        >
          <div className="">
            <h1 class="text-amber-500 font-mtn text-2xl font-semibold tracking-tight">
              Rendez-vous de raccordement
            </h1>
            <div className="w-full  mx-auto  mt-6">
              <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
                <label className="form-control flex flex-col  gap-2  w-full">
                  <label className="form-control  w-full">
                    <div className="label -mb-1">
                      <span className="label-text font-medium">
                        Date du rendez-vous{" "}
                        <span className="text-red-500">*</span>
                      </span>
                    </div>

                    <div className="px-2 flex items-center gap-2 border-[2px] w-full h-9 rounded-lg cursor-pointer">
                      <CalendarIcon className="" />
                      <ReactDatePicker
                        locale="fr"
                        dateFormat="dd-MM-yyyy"
                        minDate={minSelectableDate}
                        selected={dateStartRaccord}
                        className="py-1 bg-transparent border-none focus:outline-none cursor-pointer text-sm"
                        onChange={(date) => {
                          setStartDateRaccord(date);
                        }}
                        placeholderText="Choisir une date"
                      />
                    </div>
                  </label>
                  <div className="flex flex-row gap-2">
                    <label className="form-contro  w-full">
                      <div className="label -mb-1">
                        <span className="label-text font-medium">
                          Créneau horaire{" "}
                          <span className="text-red-500">*</span>
                        </span>
                      </div>
                      <select
                        {...register("creneauIdRaccord", { required: true })}
                        className="select select-bordered w-full h-10"
                      >
                        <option value={""} disabled selected>
                          Choisir un Créneau
                        </option>
                        {creneau
                          ?.filter((e) => e?.isActif === true)
                          .map((item) => (
                            <option value={item.id}>
                              {item.heureDebut} - {item.heureFin}
                            </option>
                          ))}
                      </select>
                    </label>
                  </div>
                </label>
              </div>
            </div>
            <SubmitButton isSubmit={isSubmit} label={"Enregistrer"} />
          </div>
        </form>
      ) : (
        <ValidateMessage
          texte={"Prise de rendez-vous de raccordement effectuée"}
        />
      )}
      <div className="w-full mt-4">
        <hr />
        <div
          className="flex mt-4"
          sx={{ display: "flex", flexDirection: "row", pt: 2 }}
        >
          <Box sx={{ flex: "1 1 auto" }} />
          <span
            disabled={isSubmit !== null ? true : false}
            className={`bg-[#ffcb05] btn btn-sm py-1 px-2 font-medium rounded-lg `}
            onClick={() => {
              window.history.back();
              localStorage.removeItem("numeroTicket");
            }}
          >
            Terminer
          </span>
        </div>
      </div>
    </>
  );
};
